import {PasswordWithEmailT} from '@/lib/types/authentication.types';
import {FormFieldT, FormStepT} from '@/lib/types/form.types';

/****************************************************************************
 * Form Fields
 ****************************************************************************/
export const signInFormFields: FormFieldT<PasswordWithEmailT>[] = [
  {
    name: 'email',
    type: 'email',
    placeholder: 'Email',
    options: {
      required: 'Email is required',
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Invalid email address',
      },
    },
  },
  {
    name: 'password',
    type: 'password',
    placeholder: 'Password',
    options: {
      required: 'Password is required',
    },
  },
];

export type SignInFieldNamesT = (typeof signInFormFields)[number]['name'];

/****************************************************************************
 * Form Steps
 ****************************************************************************/
export const signInFormSteps: FormStepT<SignInFieldNamesT> = [
  {
    step: 0,
    label: 'Sign In',
    fields: ['email', 'password'],
  },
];
